/** 登录方式：1 密码 / 2 验证码 / 3 扫码 / 4 授权 */
export const LOGIN_TYPE = {
  PASSWORD: '1',
  SMS: '2',
  QRCODE: '3',
  OAUTH: '4'
}

export const LOGIN_TYPE_VALUES = Object.values(LOGIN_TYPE)

export const DEFAULT_LOGIN_TYPE = LOGIN_TYPE.QRCODE

export const QRCODE_POLL_INTERVAL_MS = 3000

export const SMS_COUNTDOWN_SECONDS = 60

export const AGREEMENT_TYPE_TITLE = {
  member_agreement: '用户协议',
  member_privacy: '隐私协议'
}

export const QRCODE_STATUS = {
  WAITING: 'waiting',
  READY: 'ready',
  EXPIRED: 'expired',
  SUCCESS: 'success'
}
